export const proteinNameNormalize = (string) => {
    var str = string.toLowerCase();
    const greekMap = {
        'α': 'alpha',
        'β': 'beta',
        'γ': 'gamma',
        'δ': 'delta',
        'ε': 'epsilon',
        'ζ': 'zeta',
        'η': 'eta',
        'θ': 'theta',
        'ι': 'iota',
        'κ': 'kappa',
        'λ': 'lambda',
        'μ': 'mu',
        'ν': 'nu',
        'ξ': 'xi',
        'ο': 'omicron',
        'π': 'pi',
        'ρ': 'rho',
        'σ': 'sigma',
        'τ': 'tau',
        'υ': 'upsilon',
        'φ': 'phi',
        'χ': 'chi',
        'ψ': 'psi',
        'ω': 'omega'
    };
    // Replace Greek letters with their names
    str = str.replace(/[\u{0370}-\u{03FF}]/gu, match => greekMap[match] || match);
    // Replace non-alphanumeric characters with underscore
    str = str.replace(/[^a-z0-9]/g, '_');
    // Replace multiple underscores with a single one
    str = str.replace(/_+/g, '_');
    // Trim leading and trailing underscores
    str = str.replace(/^_+|_+$/g, '');
    return str;
}
